export const Languages = [
  { value: 'en', name: 'English', flag: 'assets/images/british.png' },
  { value: 'ar', name: 'العربية', flag: 'assets/images/saudi-arabia.png' },
];

